<template>
    <div class="flex w-full border-b border-a-brown-d7c7b8 py-2 cursor-pointer" @click="selectBranch()">
        <div class="w-4/5" :class="[isClose ? 'text-a-brown-9f8273' : 'text-a-brown-d7c7b8']">
            <div class="font-bold text-14 lg:text-16 pb-1"
                :class="[isClose ? 'text-a-red-d62300' : 'text-a-brown-d7c7b8']">
                {{getName()}} 
                {{!isOnline ? lbl.deliverymethod.branch_closed : ''}}
            </div>

            <div class="text-14 lg:text-16">
                <div class="flex items-center">
                    <img v-if="isClose" class="h-15px mr-3px" src="@/assets/icon/ic-pick-up-active.svg" />
                    <img v-else class="h-15px mr-3px" src="@/assets/icon/ic-pick-up-inactive.svg" />
                    <template v-if="isPickupWorkingDay">
                        {{lbl.deliverymethod.self_pickup}}
                    </template>
                    <template v-else>
                        {{ lbl.deliverymethod.no_self_pickup }}
                    </template>
                </div>
                <div class="ml-18px">
                    <template v-if="isPickupWorkingDay">
                        <div v-html="getPickupWorkingDay()"></div>
                    </template>
                </div>

                <div class="flex items-center">
                    <img v-if="isClose" class="h-15px mr-3px" src="@/assets/icon/ic-delivery-active.svg" />
                    <img v-else class="h-15px mr-3px" src="@/assets/icon/ic-delivery-inactive.svg" />
                    <template v-if="isWorkingDay">
                        {{lbl.deliverymethod.delivery}}
                    </template>
                    <template v-else>
                        {{ lbl.deliverymethod.no_delivery }}
                    </template>
                </div>
                <div class="ml-18px">
                    <template v-if="isWorkingDay">
                        <div v-html="getWorkDay()"></div>
                    </template>
                </div>
            </div>

        </div>
        <div class="w-1/5">
            <div class="text-14 text-a-brown-502314 text-right"
                :class="[isClose ? 'text-a-brown-502314' : 'text-a-brown-d7c7b8']"
            >{{FilterNumberDecimalFormat(getKM(),1)}} Km</div>
        </div>
    </div>
</template>

<script>
import LocaleMixin from "@/mixin/LocaleMixin.js";
export default {
    name: "BranchItem",
    mixins: [LocaleMixin],
    props: {
        branch: Object,
    },
    data: function() {
        return {
            
        };
    },
    computed: {
        isOnline: function() {
            if(this.branch.isOnline && this.isBranchOpen === false && this.isPickupBranchOpen === false) {
                console.log('branch ::', this.branch)
            }

            //if (this.$route.name == "SelectBranch") {
                return this.branch.isOnline;
            // } else {
            //     return true;
            // }
        },
        isBranchOpen: function() {
            return this.branch.isBranchOpen
        },
        isPickupBranchOpen: function() {
            return this.branch.isPickupBranchOpen  
        },
        isWorkingDay: function() {
            if (this.localeCode == 1033) {
                return this.branch.workingDayEn !== null
            } else {
                return this.branch.workingDay !== null
            }
        },
        isPickupWorkingDay: function() {
            if (this.localeCode == 1033) {
                return this.branch.pickupWorkingDayEn !== null
            } else {
                return this.branch.pickupWorkingDay !== null
            }
        },
        isClose: function() {
            if(this.isOnline){
                if(!this.isBranchOpen && !this.isPickupBranchOpen){
                    return false
                }
                return true
            }
            return false
        }
    },
    created: function() {

    },
    methods: {
        selectBranch: function() {
            if (!this.isOnline) return;
            this.$emit("selectBranch",this.branch);
        },
        getName: function() {
            if (this.localeCode == 1033) {
                return this.branch.nameEN
            } else {
                return this.branch.name
            }
        },
        getWorkDay: function() {
            if (this.localeCode == 1033) {
                return this.branch.workingDayEn
            } else {
                return this.branch.workingDay
            }
        },
        getPickupWorkingDay: function() {
            if (this.localeCode == 1033) {
                return this.branch.pickupWorkingDayEn
            } else {
                return this.branch.pickupWorkingDay
            }
        },
        getKM: function() {
            return this.branch.distance / 1000;
        },
    },
    mounted() {
    }
}
</script>

<style>

</style>